import { AcceptUserInviteSlug } from "@med_poc/types";
import { Router } from "@angular/router";
import { ApiService } from "../../../app/services/api/api.service";
//@ts-ignore
const qs = require('qs');

export const signupProfessionalSlug = 'signupProfessional';
export const acceptUserInviteSlug : AcceptUserInviteSlug = 'acceptUserInvite';
export const userLoginSlug = 'userLogin';
export const homeSlug = 'home';
export const profileSlug = 'profile';
export const relatedUserSlug = 'relatedUser';
export const eCITSlug = 'ecit';
export const requestPasswordSlug = 'forgot-password';
export const resetPasswordSlug = 'reset-password';
export const aboutUsSlug = 'about-us';
export const callbacksSlug = 'callbacks';
export const oidcCallbackSlug = 'oidc';

export type ProfileTab = 'info' | 'documents' | 'settings';


/**
 * /userLogin
*/
export function userLoginPath() {
  return `/${userLoginSlug}`;
}

/**
 * /signupProfessional
*/
export function signupProfessionalPath() {
  return `/?${signupProfessionalSlug}`;
}
/**
 * /home
*/
export function homePath() {
  return `/${homeSlug}`;
}

/**
 * /about us 
 */

export function aboutUsPath(){
  return `/${aboutUsSlug}`
}

/**
 * /callbacks/oidc
*/
export function oidcCallbackPath() {
  return `/${callbacksSlug}/${oidcCallbackSlug}`;
}

/**
 *
 * /acceptUserInvite
*/
export function acceptUserInvitePath() {
  return `/${acceptUserInviteSlug}`;
}

/**
 *
 * /profile
*/
export function profilePath() {
  return `/f/${profileSlug}`;
}


// ROUTER_  values are to be used in routers
export const ROUTER_SIGNUP_URL_PROFESSIONAL = {
    command: ['/'],
    extras: { queryParams: { signupProfessional: true } }
}
export const ROUTER_LOGIN_URL = {
    command: [userLoginPath()],
    extras: { }
}
export const ROUTER_PROFILE_URL = {
    command: [profilePath()],
    extras: { }
}

export const LOGIN_URL_PROFESSIONAL = `${ROUTER_SIGNUP_URL_PROFESSIONAL.command[0]}?${qs.stringify(ROUTER_SIGNUP_URL_PROFESSIONAL.extras?.queryParams)}`;

export const navigateToSignupAndRedirectAfter = (router: Router, api: ApiService, redirectTo? : `/${string}`): void => {
    console.devlog("Navigating to signup page, redirecting after to ", redirectTo);
    if (!!redirectTo) {
        localStorage.setItem('redirectToAfterLogin', redirectTo);
    }
    router.navigate(ROUTER_SIGNUP_URL_PROFESSIONAL.command, ROUTER_SIGNUP_URL_PROFESSIONAL.extras);
};

export const navigateToLoginAndRedirectAfter = (router: Router, redirectTo? : `/${string}`): void => {
  console.devtrace("Who called?");
    console.devlog("Navigating to login page, redirecting after to ", redirectTo);
    if (!!redirectTo) {
        localStorage.setItem('redirectToAfterLogin', redirectTo);
    }
    router.navigate(ROUTER_LOGIN_URL.command, ROUTER_LOGIN_URL.extras);
}

export const navigateToProfile = (router: Router, tab: ProfileTab): void => {
  router.navigate(['/', 'f', profileSlug, 'me', tab]);
}

export const navigateToGroupsPage = (router: Router): void => {
  router.navigate(['/', 'f', 'groups' ])
}

export const navigateToPasswordChange = (router: Router): void => {
  navigateToProfile(router, 'settings')
}

export const navigateToPaymentPage = (router: Router): void => {
  router.navigate(['/', 'f', 'paymentdetails'])
}